import axios from "axios";
import { API_V1_ADMIN_BASE } from "../config/api";

const apiClient = axios.create({
  baseURL: API_V1_ADMIN_BASE,
  // Live fallbacks (uncomment baseURL above to use):
  // baseURL: "https://navo-admin.viaspark.site/api/v1/admins/",
  // baseURL: "https://navoapi.viaspark.site/api/v1/admins/",
  headers: {
    "Content-Type": "application/json",
    ["expo-api-key"]: process.env.REACT_APP_EXPO_API_KEY,
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    // FormData must set its own multipart boundary (not application/json)
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const clearAuthAndRedirect = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
  localStorage.removeItem("tokenExpiration");

  // Avoid redirect loops if we're already on the login screen
  if (!window.location.pathname.startsWith("/login")) {
    window.location.assign("/login");
  }
};

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === "ERR_NETWORK") {
      console.error(
        "Network Error - Please check your connection or API availability"
      );
    }

    const status = error.response?.status;
    const requestUrl: string = error.config?.url ?? "";

    // Session expired / token invalid: clear stale token and send user to login
    // (skip the login request itself so wrong-credential errors still surface)
    if (status === 401 && !requestUrl.includes("auth/login")) {
      clearAuthAndRedirect();
    }

    return Promise.reject(error);
  }
);

export default apiClient;
